import React, { useEffect, useMemo, useState } from "react";
import { Alert, Box, Button, Paper, TextField, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { NINJAONE_OAUTH_CALLBACK_MESSAGE } from "../utils/ninjaOneOAuth";

const NinjaOneOAuthCallback: React.FC = () => {
  const [copied, setCopied] = useState(false);
  const [sentToOpener, setSentToOpener] = useState(false);
  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const code = params.get("code") || "";
  const state = params.get("state") || "";
  const error = params.get("error") || "";
  const errorDescription = params.get("error_description") || "";

  useEffect(() => {
    if (!window.opener || window.opener.closed) return;
    window.opener.postMessage(
      {
        type: NINJAONE_OAUTH_CALLBACK_MESSAGE,
        code,
        state,
        error,
        errorDescription,
      },
      window.location.origin
    );
    setSentToOpener(true);
    window.setTimeout(() => window.close(), 1200);
  }, [code, error, errorDescription, state]);

  const handleCopy = async () => {
    if (!code) return;
    await navigator.clipboard.writeText(code);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2500);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f8fafc",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 3,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: 640,
          p: 4,
          border: "1px solid #E5E7EB",
          borderRadius: "6px",
          bgcolor: "#fff",
        }}
      >
        <Typography sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 24, fontWeight: 700, color: "#111827", mb: 1 }}>
          NinjaOne Sign-In Complete
        </Typography>
        <Typography sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 14, color: "#4B5563", lineHeight: 1.6, mb: 3 }}>
          {sentToOpener
            ? "Theo is filling the Refresh Token. This window will close automatically."
            : "Return to Theo. The NinjaOne setup form should fill the Refresh Token automatically."}
        </Typography>

        {error ? (
          <Alert severity="error" sx={{ fontFamily: "var(--theo-font-sans)", mb: 2 }}>
            {errorDescription || error}
          </Alert>
        ) : code && !sentToOpener ? (
          <>
            <TextField
              label="Authorization Code"
              value={code}
              fullWidth
              multiline
              minRows={3}
              InputProps={{ readOnly: true }}
              sx={{ mb: 2, "& .MuiInputBase-input": { fontFamily: "monospace", fontSize: 13 } }}
            />
            <Button
              variant="contained"
              startIcon={<ContentCopyIcon />}
              onClick={handleCopy}
              sx={{ fontFamily: "var(--theo-font-sans)", textTransform: "none", bgcolor: "#705D4A" }}
            >
              {copied ? "Copied" : "Copy Code"}
            </Button>
          </>
        ) : (
          <Alert severity="warning" sx={{ fontFamily: "var(--theo-font-sans)" }}>
            NinjaOne did not return the expected sign-in result.
          </Alert>
        )}
      </Paper>
    </Box>
  );
};

export default NinjaOneOAuthCallback;
